import { useSEO } from "../lib/seo";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const CONTENT = {
    kvkk: {
        title: "KVKK Aydınlatma Metni",
        body: [
            "Cegu Masaj Salonu Özlüce olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında veri sorumlusu sıfatıyla kişisel verilerinizin işlenmesi hakkında sizi bilgilendirmek isteriz.",
            "Kişisel verileriniz; randevu oluşturma, hizmetin sunulması, iletişim, memnuniyet ölçümü ve yasal yükümlülüklerin yerine getirilmesi amaçlarıyla işlenir.",
            "Söz konusu kişisel veriler yalnızca yasal süreler boyunca saklanır ve gerekli olduğunda yetkili kurumlarla paylaşılır. Verilerinize ilişkin haklarınızı kullanmak için bize WhatsApp hattımızdan ulaşabilirsiniz.",
        ],
    },
    gizlilik: {
        title: "Gizlilik Politikası",
        body: [
            "Cegu Masaj Salonu Özlüce web sitesi ziyaretçilerinin gizliliğine önem verir.",
            "Bu sitede toplanan bilgiler yalnızca hizmet kalitesini artırmak, kullanıcı deneyimini iyileştirmek ve iletişim amacıyla kullanılır.",
            "Kişisel verileriniz üçüncü taraflarla ticari amaçla paylaşılmaz.",
        ],
    },
    cerez: {
        title: "Çerez Politikası",
        body: [
            "Web sitemiz, tarayıcınızda çerezler (cookies) kullanabilir.",
            "Bu çerezler; site performansını iyileştirmek, ziyaretçi analitiği yapmak ve size daha iyi bir deneyim sunmak için kullanılır.",
            "Tarayıcı ayarlarınızdan çerezleri her zaman devre dışı bırakabilirsiniz.",
        ],
    },
};

export default function Legal({ type }) {
    const c = CONTENT[type];
    useSEO({
        title: `${c.title} — Cegu Masaj Salonu Özlüce`,
        description: c.body[0].slice(0, 160),
        canonical: `/${type}`,
    });

    return (
        <main className="bg-[#0d0d0f] pt-[120px] min-h-screen pb-16">
            <div className="container-x max-w-3xl">
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 text-[13px] text-[#c8c3ba] hover:text-[#c9a24b] mb-6"
                >
                    <ArrowLeft className="w-4 h-4" />
                    Ana Sayfa
                </Link>
                <div className="eyebrow mb-3">Yasal</div>
                <h1 className="h1 text-[#f2ede4]">{c.title}</h1>
                <div className="divider-gold mt-5 mb-8" />
                <div className="space-y-5">
                    {c.body.map((p, i) => (
                        <p key={i} className="body-base">
                            {p}
                        </p>
                    ))}
                </div>
            </div>
        </main>
    );
}
